import { apiSlice } from '@/redux/apiSlice';

export const offlineApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    downloadProject: builder.mutation({
      query: (projectId) => ({
        url: `/offline/download/${projectId}`,
        method: 'GET',
      }),
    }),
    uploadProject: builder.mutation({
      query: (body) => ({
        url: `/offline/upload/${body.projectId}`,
        method: 'POST',
        body: { selectedSections:body.selectedStages, ...body },
      }),
    }),
    syncStatus: builder.query({
      query: (syncSessionId) => ({
        url: `/offline/sync-status/${syncSessionId}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => ({
        ...response,
        // Calculate overall progress
        progress: response.completedStages / response.totalStages * 100,
        // Transform stages data
        stages: response.stages.map((stage: any) => ({
          ...stage,
          duration: stage.completedAt ?
            (new Date(stage.completedAt).getTime() - new Date(stage.startedAt).getTime()) / 1000
            : null
        }))
      })
    }),
  }),
});

export const {
  useDownloadProjectMutation,
  useUploadProjectMutation,
  useSyncStatusQuery
} = offlineApiSlice;
